import { forwardRef, Ref } from "react";
import { MDSIcon, MDSIconKind } from "@/mds/components/icon";
import { StyledBanner, StyledRightContainer } from "@/mds/components/banner/banner.style";
import { MdsBannerProps, MDSBannerSlotName, MDSBannerKind } from "./banner.types";
import { useTheme } from "@emotion/react";
import { getSlot } from "@/mds/utils/slots";
import { MDSIconButton, MDSIconButtonVariant } from "@/mds/components/buttons";
import { MDSText, MDSTextVariant, MDSTextColor } from "@/mds/components/text";

export const MDSBanner = forwardRef(function MDSBanner(
  { kind, message, iconKind, iconColor, children, onDismiss }: MdsBannerProps,
  ref: Ref<HTMLElement>
) {
  const theme = useTheme();
  const computedIconColor =
    iconColor ?? (kind === MDSBannerKind.Error ? theme.colors.text.danger : undefined);
  return (
    <StyledBanner ref={ref} kind={kind} showDismissBtn={!!onDismiss} data-mds-name="banner">
      {iconKind && <MDSIcon kind={iconKind} overrideColor={computedIconColor} />}
      {getSlot(children, MDSBannerSlotName.Left)}
      {message && (
        <MDSText
          variant={MDSTextVariant.ParagraphS}
          color={kind === MDSBannerKind.Error ? MDSTextColor.Danger : undefined}
        >
          {message}
        </MDSText>
      )}

      <StyledRightContainer data-component="banner-right-container">
        {getSlot(children, MDSBannerSlotName.Right)}
        {onDismiss && (
          <MDSIconButton
            iconKind={MDSIconKind.Exit}
            variant={MDSIconButtonVariant.Transparent}
            onClick={onDismiss}
          />
        )}
      </StyledRightContainer>
    </StyledBanner>
  );
});
